<!-- 底页链接管理 footlist-->
<template>
  <div class="footlist">
    <div class="form_header">
      <el-form ref="form" :model="userform" label-width="100px">
        <div class="form_list">
          <el-form-item label="上级栏目：">
            <el-select v-model="userform.i_id" placeholder="请选择上级">
              <el-option v-for="item in footlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="nosub">取消</el-button>
          </div>
        </div>
      </el-form>
      <div>
        <!-- <el-button type="primary" icon="el-icon-upload2">导出</el-button> -->
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      </div>
    </div>
    <div class="user_list">
      <el-table :data="footlistList" style="width: 100%" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="category" label="上级" width="200">
          <template slot-scope="scope">
            <span>{{scope.row.category.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" width="200"></el-table-column>
        <el-table-column prop="img" label="图标" width="100">
          <template slot-scope="scope">
            <div style="background-color:#000;width: 40px; height: 40px" v-if="scope.row.img!==''">
              <el-image style="width: 40px; height: 40px" :src="domainUrl+scope.row.img" :preview-src-list="scope.row.PCsrcList"></el-image>
            </div>
            <div v-else style="width: 40px; height: 40px">无</div>
          </template>
        </el-table-column>
        <el-table-column prop="link" label="链接"></el-table-column>
        <el-table-column prop="pc_img" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">隐藏</span>
            <span v-if="scope.row.status==1">正常</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button @click="removesize(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 新增--编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="cancelform">
      <el-form :model="Edform" :rules="rules" label-width="100px">
        <el-form-item label="所属栏目">
          <el-select v-model="Edform.i_id" placeholder="请选择上级" @change="lance">
            <el-option v-for="item in footlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示方式">
          <!-- <el-select v-model="Edform.Product" placeholder="请选择状态">
            <el-option label="图片" value="1"></el-option>
            <el-option label="文字" value="0"></el-option>
          </el-select>-->
          <span v-if="Edform.Product==0">文字</span>
          <span v-if="Edform.Product==1">图片</span>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="Edform.name"></el-input>
        </el-form-item>
        <el-form-item label="图标">
          <el-upload action list-type="picture-card" :http-request="(file)=>handaddimg(file,1)" accept=".png, .jpg, .jpeg" :limit="1" :file-list="Edform.fileList1" :class="{ hideUpload: Edform.fileList1.length > 0 }" :on-remove="(file)=>handleRemove(file,1)">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="Edform.link"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="Edform.status" placeholder="请选择状态">
            <el-option label="显示" value="1"></el-option>
            <el-option label="隐藏" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelform">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { uploadimg, hostimg } from "../../api/comm.js";
import {
  categoryLinkslists,
  linkslists,
  linksdelete,
  linksadd,
  linksedit
} from "../../api/system.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        i_id: "",
        name: ""
      },
      Edform: {
        i_id: "",
        name: "",
        Product: 3,
        link: "",
        status: "",
        fileList1: []
      },
      footlistList: [
        {
          name: "9f30002",
          num: "1000",
          category: {
            name: ""
          }
        }
      ],
      footlist: [],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }]
      },
      domainUrl: ""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //实时域名
    domainName() {
      hostimg().then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.domainUrl = res.data.url;
          this.listdata();
        }
      });
    },
    //栏目列表
    categdata() {
      categoryLinkslists({
        currency_id:parseInt(localStorage.getItem('countryId'))
      }).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.footlist = res.data.data;
        }
      });
    },
    //下拉栏目
    lance(e) {
      // console.log(e);
      this.footlist.forEach(ele => {
        if (ele.id == e) {
          this.Edform.Product = ele.type;
        }
      });
    },
    //链接列表
    listdata() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        i_id: this.userform.i_id,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      linkslists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          res.data.data.forEach((ele, i) => {
            res.data.data[i].PCsrcList = [];
            res.data.data[i].PCsrcList.push(this.domainUrl + ele.img);
            // res.data.data[i].img = this.domainUrl + ele.img;
          });
          this.footlistList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.listdata();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
      this.currentindex = 1;
      this.listdata();
    },
    //取消搜索
    nosub() {
      this.userform.i_id = "";
      this.currentindex = 1;
      this.listdata();
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.pop_up = true;
    },
    //编辑弹窗
    editbox(e) {
      this.titleName = "编辑";
      this.pop_up = true;
      // console.log(e);
      this.Edform.id = e.id;
      this.Edform.name = e.name;
      this.Edform.link = e.link;
      if (e.img !== "") {
        this.Edform.fileList1.push({
          path: e.img,
          url: e.PCsrcList[0]
        });
      } else {
        this.Edform.fileList1 = [];
      }

      this.Edform.i_id = e.i_id;
      this.Edform.status = String(e.status);
      this.Edform.Product = e.category.type;
    },
    //PC图片上传
    handaddimg(file, i) {
      // console.log(file);
      let minfile = file.file;
      let form = new FormData();
      form.append("file", minfile);
      uploadimg(form).then(res => {
        // console.log(res);
        // console.log(this.Edform.fileList);
        if (res.status_code == 200) {
          this.Edform.fileList1 = [];
          //PC图片
          if (i == 1) {
            this.Edform.fileList1.push({
              name: res.data.original_name,
              url: res.data.url,
              path: res.data.path
            });
          }
        }
      });
    },
    //PC删除上传
    handleRemove(file, i) {
      // console.log(file);
      //PC图片
      if (i == 1) {
        this.Edform.fileList1 = [];
      }
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.Edform);
      if (this.titleName == "新增") {
        // linksadd
        if (this.Edform.Product == 0) {
          var data = {
            name: this.Edform.name,
            link: this.Edform.link,
            img: "",
            i_id: this.Edform.i_id,
            status: this.Edform.status,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          linksadd(data).then(res => {
            if (res.status_code == 200) {
              this.pop_up = false;
              this.cancelform();
              this.currentindex = 1;
              this.listdata();
              this.$message({
                type: "success",
                message: "添加成功!"
              });
            }
          });
        } else {
          if (this.Edform.fileList1.length > 0) {
            var data = {
              name: this.Edform.name,
              link: this.Edform.link,
              img: this.Edform.fileList1[0].path,
              i_id: this.Edform.i_id,
              status: this.Edform.status,
              currency_id:parseInt(localStorage.getItem('countryId'))
            };
            linksadd(data).then(res => {
              if (res.status_code == 200) {
                this.pop_up = false;
                this.cancelform();
                this.currentindex = 1;
                this.listdata();
                this.$message({
                  type: "success",
                  message: "添加成功!"
                });
              }
            });
          } else {
            this.$message({
              type: "warning",
              message: "请上传图标!"
            });
          }
        }
        // console.log(data);
      }
      if (this.titleName == "编辑") {
        if (this.Edform.Product == 0) {
          var data = {
            id: this.Edform.id,
            name: this.Edform.name,
            link: this.Edform.link,
            img: "",
            i_id: this.Edform.i_id,
            status: this.Edform.status,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          linksedit(data).then(res => {
            if (res.status_code == 200) {
              this.pop_up = false;
              this.cancelform();
              this.currentindex = 1;
              this.listdata();
              this.$message({
                type: "success",
                message: "修改成功!"
              });
            }
          });
        } else {
          if (this.Edform.fileList1.length > 0) {
            var data = {
              id: this.Edform.id,
              name: this.Edform.name,
              link: this.Edform.link,
              img: this.Edform.fileList1[0].path,
              i_id: this.Edform.i_id,
              status: this.Edform.status,
              currency_id:parseInt(localStorage.getItem('countryId'))
            };
            linksedit(data).then(res => {
              if (res.status_code == 200) {
                this.pop_up = false;
                this.cancelform();
                this.currentindex = 1;
                this.listdata();
                this.$message({
                  type: "success",
                  message: "修改成功!"
                });
              }
            });
          } else {
            this.$message({
              type: "warning",
              message: "请上传图标!"
            });
          }
        }
      }
    },
    //关闭弹窗
    cancelform() {
      this.Edform.name = "";
      this.Edform.link = "";
      this.Edform.Product = 3;
      this.Edform.i_id = "";
      this.Edform.status = "";
      this.Edform.fileList1 = [];
      this.pop_up = false;
    },
    //删除
    removesize(e) {
      // console.log(e);
      let data = {
        id: e.id
      };
      linksdelete(data).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.listdata();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.categdata();
    this.domainName();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.footlist {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.footlist {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
  .hideUpload {
    .el-upload.el-upload--picture-card {
      display: none !important;
    }
    .is-success {
      background-color: #000;
    }
  }
}
</style>